import angular from 'angular';

class Button {

  constructor(label = '',
              callback = () => {
                console.log('empty callback for button with label ' + label + ' and index ' + pageIndex);
              },
              pageIndex = 0
  ) {
    this.label = label;
    this.pageIndex = pageIndex;
    this.callback = callback;
  }

}

class PaginationRemote {
  /* @ngInject */
  constructor($log, $scope, PaginationSettings) {

    const that = this;

    that.buttons = [];

    that.paginationOptions = {
      pageButtonsToShow: 5
    };

    that.paginationCursor = {
      totalPages: 0,
      selectedPageIndex: 0
    };


    const drawButtons = (forceDraw = false) => {


      let buttonsLapses = Math.floor(that.paginationCursor.totalPages / that.paginationOptions.pageButtonsToShow) +
        ((that.paginationCursor.totalPages % that.paginationOptions.pageButtonsToShow) !== 0 ? 1 : 0);
      let selectedPage = that.paginationCursor.selectedPageIndex + 1;
      let currentButtonLapse = Math.floor(selectedPage / that.paginationOptions.pageButtonsToShow);
      let lowerButtonsBound = (that.paginationOptions.pageButtonsToShow * currentButtonLapse) + 1;
      let higherButtonsBound = lowerButtonsBound + that.paginationOptions.pageButtonsToShow;
      let lowerButtonsBoundIndex = lowerButtonsBound - 1;
      let higherButtonsBoundIndex = higherButtonsBound - 1;

      if (that.paginationCursor.selectedPageIndex <= higherButtonsBoundIndex
        &&
        that.paginationCursor.selectedPageIndex >= lowerButtonsBoundIndex
        &&
        !forceDraw) {
        return;
      }

      that.buttons = [];

      for (let i = lowerButtonsBound; i < higherButtonsBound && i <= that.paginationCursor.totalPages; i++) {
        let currentIndex = i - 1;
        that.buttons.push(
          new Button(
            i,
            () => {
              $log.log('pressed button with index : ' + currentIndex);
              that.pageChangedButtonPressed(currentIndex);
            },
            currentIndex
          )
        );

      }


      if (lowerButtonsBoundIndex !== 0) {
        that.buttons.unshift(
          new Button(
            '1',
            () => {
              that.pageChangedButtonPressed(0);
            },
            0
          ),
          new Button(
            '...',
            () => {
              let pageIndex = lowerButtonsBoundIndex - 1;
              that.pageChangedButtonPressed(pageIndex - 1);
            },
            lowerButtonsBoundIndex - that.paginationOptions.pageButtonsToShow
          )
        );
      }


      if (higherButtonsBoundIndex < that.paginationCursor.totalPages) {
        that.buttons.push(
          new Button(
            '...',
            () => {
              let pageIndex = higherButtonsBoundIndex + 1;
              that.pageChangedButtonPressed(pageIndex);
            },
            higherButtonsBoundIndex + 1
          ),
          new Button(
            that.paginationCursor.totalPages,
            () => {
              let pageIndex = that.paginationCursor.totalPages - 1;
              that.pageChangedButtonPressed(pageIndex);
            },
            that.paginationCursor.totalPages - 1
          )
        );
      }


    };

    /*
    *
    *  PageChangedButtonPressed(pageIndex) must return a boolean in order to notificate the state of operation
    *
    *   eg:
    *       PageChangedButtonPressed = (pageIndex) => {
    *           retrieve operations ...
    *           return true;
    *       };
    *
     */

    const setPagesNumber = (numberOfPages) => {
      that.paginationCursor.totalPages = numberOfPages;
      drawButtons(true);
    };

    const setCurrentPageIndex = (currentPageIndex = 0) => {
      that.paginationCursor.selectedPageIndex = currentPageIndex;
    };

    const init = () => {

      that.paginationOptions = {
        pageButtonsToShow: 5
      };

      that.setPagesNumber = setPagesNumber;

      that.setCurrentPageIndex = setCurrentPageIndex;

      that.paginationCursor = {
        totalPages: 0,
        selectedPageIndex: 0
      };

    };

    that.$onInit = init;


  }
}

export default PaginationRemote;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/pagination-remote/paginationRemote.controller.js
 **/